import Ascii1 from "./components/assets/ascii1";
import CatAscii from "./components/assets/ascii1";
import Ascii2 from "./components/assets/ascii2";
import "./index.css";

export function App() {
    const prefix = `₍^. .^₎⟆⠀>>⠀`;
    return (
        <div className="bg-neutral-950 flex text-white p-4 md:p-8 gap-8 select-none justify-between items-center w-screen min-h-screen">
            {/*<Ascii1 />*/}
            <div className="lg:max-w-1/2 flex items-center justify-center w-full">
                <div className="bg-neutral-900 border rounded-xl overflow-hidden border-neutral-700/80 w-full max-w-lg flex items-center justify-center flex-col">
                    <div className="w-full relative border-b border-neutral-700/60 bg-neutral-800 py-2.5 flex items-center justify-center">
                        <div className="flex items-center absolute left-3 top-1/2 -translate-y-1/2 gap-2 w-12">
                            <div className="w-3 h-3 aspect-square rounded-full bg-red-500/90" />
                            <div className="w-3 h-3 aspect-square rounded-full bg-amber-500/90" />
                            <div className="w-3 h-3 aspect-square rounded-full bg-emerald-500/90" />
                        </div>
                        <span className="font-mono text-xs text-neutral-400">
                            <span className="animate-blink text-blue-300">
                                &gt;
                            </span>{" "}
                            ssh paw@mitzilab.com
                        </span>
                    </div>
                    <div className="font-dynapuff text-sm py-2.5 flex flex-col items-start w-full px-2.5 justify-center">
                        <span>{prefix}MitziLab</span>
                        <span>
                            {prefix}Home of different services I expose to the
                            internet
                        </span>
                    </div>
                </div>
            </div>
            <div className="lg:flex hidden text-xs items-center justify-center w-full max-w-1/2">
                <Ascii2 />
            </div>
        </div>
    );
}

export default App;
